import { combineReducers } from "redux";

import userDetails from "./user";
import inventory from "./inventory";
import companies from "./company";
import installers from "./installers";

const rootReducer = combineReducers({
    userDetails,
    inventory,
    companies,
    installers
});

export default rootReducer;